import React, { Suspense } from 'react'
import { LoadingState } from '@asad/crane-ui'

type ReturnType<T> = (props: T) => JSX.Element

// eslint-disable-next-line @typescript-eslint/ban-types
export const withLoading = <T extends object>(Component: React.ComponentType<T>): ReturnType<T> => {
  return (props: T) => (
    <Suspense fallback={<LoadingState className='flex-1' />}>
      <Component {...props} />
    </Suspense>
  )
}
